<template>
  <div id="indicator-content">
    <div id="indicator-icons">
    
      <h2>VIEW COMPOSITE RESULTS <small>Toggle indicators to filter data</small></h2>
      
      <div class="indicator-groups">
        <div class="indicator-group" 
          :class="{active: isGroupActive(group_index) }" 
          v-for="indicator,group_index in indicators" 
          :key="group_index">

          <h3>
            <img :src="loadImg(indicator.icon)">
            <span v-text="indicator.name"></span>
          </h3>
          <span class="show-all" @click="setAllActive(group_index)">select all</span>
          <ul>
            <li 
              :class="{active: i.active}" 
              @click="setActiveIndicator(i, group_index)"
              v-for="i in indicator.indicators" v-if="i.name !== 'Overview'">
              <img :src="loadImg(i.image)" />
              <span class="indicator-name" v-text="i.name"></span>
            </li>
          </ul>

        </div>
      </div>
    
    </div>

    <div class="slick-wrapper" v-if="slickVisible">
      <slick id="indicator-cards-slider" ref="slick" :options="slickOptions">

          <div class="indicator-card"
            v-for="indicator,index in flattened_indicators" 
            :class="[{'card-slide': (indicator.first || indicators[indicator.group].expanded)}, 'group-indicator-' + indicator.group ]"
            :key="index" v-if="indicator.name !== 'Overview'">

            <div @click="toggleIndicatorGroup(indicator.group)" class="vertical-collapsed" v-if="indicator.first && !indicators[indicator.group].expanded">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
              <img class="icon" :src="loadImg(indicators[indicator.group].icon)">
              <span>{{indicators[indicator.group].name}}</span>
            </div>

            <div v-else-if="indicators[indicator.group].expanded">
              <div class="indicator-card-top">
                <span v-if="indicator.first" class="indicator-card-top__left">
                  <img :src="loadImg(indicators[indicator.group].icon)">
                  {{indicators[indicator.group].name}}
                </span>
                <span @click="toggleIndicatorGroup(indicator.group)" v-if="indicator.last" class="indicator-card-top__right">
                  collapse
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </span>
              </div>

              <div class="indicator-details-card" :class="{ context: indicator.group == 0, core: indicator.group == 1, opp: indicator.group == 2, active: indicator.active }">
                <img v-if="indicator.thumb" :src="loadImg(indicator.thumb)" />
                <div class="indicator-details-content">
                  <h5>
                    {{ indicator.fullname }}
                    <span class="composite-score" v-if="indicator.composite" v-html="indicator.composite"></span>
                  </h5>

                  <div class="indicator-description">
                    <img :src="loadImg(indicator.image)">
                    {{ indicator.description }}
                  </div>

                  <div class="indicator-calculation">
                    <h6>How Indicator Was Calculated</h6>
                    {{ indicator.calculation }}
                  </div>

                  <div class="indicator-source">
                    <h6>Data Source (and date):</h6>
                    {{ indicator.source }}
                  </div>
                </div>
              </div>
              <!-- <img class="indicator-card-content" :class="{active: indicator.active}" :src="loadImg(indicator.card)" /> -->
            </div>

          </div>

      </slick>
    </div>

  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'indicators',
  components: {
    Slick
  },
  computed: {
    indicators () {
      return this.$store.getters.getIndicators
    },
    selectedMills() {
      return this.$store.getters.getSelectedMills
    },
    flattened_indicators () {
      return _.flatten(_.map(this.indicators, function(indicator, indicator_index){
        return _.map(indicator.indicators, function(single, index){
          single.group = indicator_index
          if(index === 0)
            single.first = true
          if(index === indicator.indicators.length - 1)
            single.last = true

          return single
        });
      }))
    }
  },
  methods: {
    loadImg: function (path) {
      return require('../assets/' + path)
    },
    individualIndicatorActive(indicator, group_index) {
      return this.active_group === null || (this.active_group === group_index && (this.active_indicator === null || this.active_indicator === indicator.name))
    },
    isGroupActive(group_index) {
      var num_active = _.countBy(this.indicators[group_index].indicators, function(i) { return i.active ? 'active' : 'inactive'; })
      return num_active.active > 0;
    },
    setAllActive(group_index) {
      this.indicators[group_index].indicators.forEach(function(i){
        i.active = true;
      });
      this.$parent.resetMapImage();
    },
    setActiveIndicator(indicator, group_index) {

      if(this.indicators[group_index].single) {
        var num_active = _.countBy(this.indicators[group_index].indicators, function(i) { return i.active ? 'active' : 'inactive'; })
        indicator.active = num_active.active > 1 ? true : !indicator.active
        this.indicators[group_index].indicators.forEach(function(i){
          if(indicator !== i) {
            i.active = false;
          }
        });
      } else {
        indicator.active = !indicator.active;
      }
      this.$parent.resetMapImage();

    },
    toggleIndicatorGroup(index) {
      this.slickVisible = false
      this.indicators[index].expanded = !this.indicators[index].expanded
      this.$nextTick(function(){
        this.slickVisible = true
        console.log(index);
        if (index === 2) {
          setTimeout(function () {
            $('#indicator-cards-slider').slick('slickGoTo', 7, false);
          }, 50);
        }
      })
    }
  },
  created (){

  },
  mounted (){
    this.$parent.setMapImage('static-zoom-in3.png')
  },
  data () {
    return {
      slickVisible: true,
      slickOptions: {
        slide: '.card-slide',
        variableWidth: true,
        // slidesToShow: 10,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
          {
            breakpoint: 1560,
            settings: {
              // slidesToShow: 7,
            }
          },
          {
            breakpoint: 1360,
            settings: {
              // slidesToShow: 6,
            }
          },
          {
            breakpoint: 1180,
            settings: {
              // slidesToShow: 5,
            }
          },
          {
            breakpoint: 1020,
            settings: {
              // slidesToShow: 4,
            }
          },
          {
            breakpoint: 830,
            settings: {
              // slidesToShow: 3,
            }
          },
          {
            breakpoint: 675,
            settings: {
              // slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss">

@import '../scss/global';

.fa-bookmark {
  color: $primary-color;
}

#indicator-content {
  height: $indicator-height;
  width: 100%;
  position: absolute;
  top: 535px;
  left: 0;
  background: #F1F0EC;
  z-index: 9;

  @include breakpoint(1440px up) {
    top: 650px;
  }

  #indicator-icons {
    width: 100%;
    // height: 115px;
    background: #cacac3;
    padding: 2px 10px;
    color: #727270;
    padding-left: 3em;

    h2 {
      color: #727270;
      text-align: left;
      margin: 0.25rem;
      font-weight: 200;
      line-height: 1em;
      font-size: 22px;
      small {
        color: #727270;
        font-size: 10px;
        // margin-left: 1em;
        white-space: nowrap;
      }
    }
  }

  .indicator-groups {
    text-align: left;

    .indicator-group {
      display: inline-block;
      margin: 2.5px;
      background: #e2e2db;
      border-radius: $global-radius;
      transition: all $animation-speed;

      h3 {
        display: inline-block;
        margin: 0;
        padding: 5px;
        font-size: 12px;
        text-transform: uppercase;
        float: left;
        text-align: center;
        width: calc(100% - 50px);
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        img {
          vertical-align: top; 
        }
      }
      .show-all {
        padding: 5px;
        font-size: 10px;
        float: right;
        position: relative;
        color: $primary-color;
        cursor: pointer;
      }

      ul {
        clear: both;
        list-style: none;
        padding: 0;
        margin: 0;
        border-top: 1px solid #cacac2;

        li {
          height: 45px;
          width: 60px;
          // float: left;
          display: inline-block;
          border-left: 1px solid #cacac2;
          background: #d8d8d1;
          // position: relative;
          cursor: pointer;
          transition: opacity $animation-speed;
          padding: 0;
          text-align: center;
          vertical-align: bottom;
          position: relative;

          @include breakpoint (1150px up) {
            height: 50px;
            width: 65px;
          }

          &:first-child {
            border: none;
            border-radius: 0 0 0 $global-radius;
          }
          &:last-child {
            border-radius: 0 0 $global-radius 0;
          }
          img {
            max-width: 25px;
            max-height: 20px;
            opacity: 0.5;
            margin: 0 auto;
            margin-top: 0.5em;
            // margin-bottom: 0.25em;
            vertical-align: middle;
            transition: opacity $animation-speed;

            @include breakpoint (1150px up) {
              max-width: 30px;
              max-height: 25px;
            }
          }
          .indicator-name {
            font-size: 9px;
            left: 0px;
            bottom: 2px;
            width: 100%;
            position: absolute;
            text-align: center;
            word-break: nowrap;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            opacity: 0.5;
            transition: opacity $animation-speed;
          }
          &.active {
            background: #f1f0ec;
            .indicator-name, img {
              opacity: 1;
            }
          }
        }

      }

      &.active {
        background: #f1f0ec;
        
      }
    }

  }

}

.slick-wrapper {
  background-color: #F1F0EC;
}

#indicator-cards-slider {
  padding: 15px 50px;
  position: relative;

  .indicator-details-card {
    background-color: #FFF;
    width: 200px;
    min-height: 530px;
    margin: 0.5em;
    border-radius: $global-radius;
    padding: 0.5em 0;
    overflow: hidden;
    color: #505050;
    position: relative;
    opacity: 0.5;
    transition: opacity 0.5s;
    box-shadow: 0px 0px 10px #CCC;

    @include breakpoint (medium up) {
      width: 222px;
    }

    &.active {
      opacity: 1;
    }

    &:before {
      content: ' ';
      display: block;
      position: absolute;
      top: 1em;
      left: 0.5em;
      width: 2em;
      height: 2em;
      background-repeat: no-repeat;
    }
    
    &.context:before {
      background-image: url('../assets/icon-indicator-context-white.png');
    }
    
    &.core:before {
      background-image: url('../assets/icon-indicator-core-white.png');
    }

    &.opp:before {
      background-image: url('../assets/icon-indicator-opp-white.png');
    }

    h5 {
      font-size: 1em;
      position: relative;
      padding-right: 4.5em;

      .composite-score {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 1.25em;

        .green {
          color: $primary-color;
        }
      }
    }

    .indicator-details-content {
      padding: 0.5em;
    }

    .indicator-description {
      font-size: 0.70em;
      margin: 1em 0;
      padding: 0.5em;
      border-top: 1px solid #E8E8E8;
      border-bottom: 1px solid #E8E8E8;
      position: relative;
      padding-left: 3em;
      text-transform: uppercase;
      min-height: 4em;

      img {
        position: absolute;
        left: 0;
        top: 1em;
        max-height: 23px;
        max-width: 23px;
      }
    }

    .indicator-calculation {
      margin-bottom: 1em;
    }

    .indicator-calculation, .indicator-source {
      font-size: 0.7em;

      h6 {
        font-size: inherit;
        text-transform: uppercase;
      }
    }
  }

  .indicator-card {
    margin: 0;
    outline: none;

    &.card-slide {
      display: block;
    }

    .vertical-collapsed {
      background: $white;
      height: 437px;
      width: 35px;
      display: block;
      border-radius: $global-radius;
      overflow: hidden;
      cursor: pointer;
      margin-right: 10px;

      .fa {
        background: $primary-color;
        color: $white;
        display: block;
        padding: 5px;
        height: 35px;
        width: 35px;
        text-align: center;
        position: relative;
        &:before {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }
      }

      img.icon {
        display: block;
        margin: 10px auto 15px;
      }

      span {
        transform: rotate(90deg);
        display: block;
        width: 250px;
        transform-origin: 18px;
      }
    }

    .indicator-card-top {
      position: relative;
      height: 18px;
      overflow: hidden;

      &:before {
        content: '';
        display: block;
        border-top: 2px solid #DEDEDA;
        position: absolute;
        top: 4px;
        width: 100%;
        z-index: 1;
      }
      &:after {
        content: '';
        display: block;
        clear: both;
      }

      span {
        padding: 0 5px;
        background: #F1F0EC;
        position: relative;
        z-index: 9;
        padding-right: 10px;
      }

      span.indicator-card-top__left {
        float: left;
        font-size: 10px;
        line-height: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        img {
          height: 10px;
          vertical-align: top;
          display: inline-block;
        }
      }

      span.indicator-card-top__right {
        float: right;
        font-size: 10px;
        line-height: 10px;
        color: $primary-color;
        cursor: pointer;
        padding-left: 10px;
        .fa {
          margin-left: 5px;
        }
      }

    }

    .indicator-card-content {
      margin-right: 10px;
      opacity: 0.5;
      transition: opacity $animation-speed;
      &.active {
        opacity: 1;
      }
    }

  }

  .slick-arrow {
    background: #FFFFFF;
    color: $primary-color;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
    width: 40px;
    height: 65px;
    font-size: 42px;
    transition: opacity $animation-speed;
    opacity: 1;
    outline: none;
    &.slick-prev {
      left: 0;
    }
    &.slick-next {
      right: 0;
    }
    &.slick-disabled {
      color: #CACAC3;
      opacity: 0.5;
    }
  }
}




</style>



// WEBPACK FOOTER //
// Indicators.vue?08c135af